export const MAX_INELIGIBLE_OPENINGS_COUNT = 3;
